import { api } from "../services/Api";

export default async function checaPedidoExistenteLog(
  pedido,
) {
  try {
    const response = await api.get("/v2/coleta/coletaExistePedido", {
      params: {
        pedido: String(pedido || ""),
      },
    });

    // API returns an envelope like: { data: boolean, messages: [], status, statusCode }
    if (typeof response?.data === "boolean") {
      return response.data;
    }

    return Boolean(response?.data?.data);
  } catch (error) {
    console.error("Erro ao salvar log:", error);
    return false;
  }
}